import { useEffect, useState, useCallback } from "react";
import { targetsController } from "../controller";

//
// 1️⃣ useFetchMetricsList
//
export const useFetchMetricsList = () => {
  const [metricsList, setMetricsList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await targetsController.getMetricsList();
      setMetricsList(res.json);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { metricsList, loading, error, refetch: fetchData };
};


//
// 2️⃣ useFetchRewardTypesAndPeriods
//
export const useFetchRewardTypesAndPeriods = () => {
  const [rewardTypes, setRewardTypes] = useState(null);
  const [periods, setPeriods] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await targetsController.getRewardTypesAndPeriods();
      setRewardTypes(res.json.reward_type_choices);
      setPeriods(res.json.period_choices);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { rewardTypes, periods, loading, error, refetch: fetchData };
};


//
// 3️⃣ useFetchOfficeUsers
//
export const useFetchOfficeUsers = () => {
  const [officeUsers, setOfficeUsers] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await targetsController.getOfficeUsers();
      setOfficeUsers(res.json);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { officeUsers, loading, error, refetch: fetchData };
};


//
// 4️⃣ useFetchActiveTargetsList
//
export const useFetchActiveTargetsList = () => {
  const [activeTargetsList, setActiveTargetsList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await targetsController.getActiveTargetsList();
      setActiveTargetsList(res.json);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { activeTargetsList, loading, error, refetch: fetchData };
};


//
// 5️⃣ useFetchAchievementSummary
//
export const useFetchAchievementSummary = () => {
  const [achievementSummary, setAchievementSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await targetsController.getAchievementSummary();
      setAchievementSummary(res.json);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { achievementSummary, loading, error, refetch: fetchData };
};


//
// 6️⃣ useFetchLeaderboards
//
export const useFetchLeaderboards = (timeRange, rewardType) => {
  const [leaderboards, setLeaderboards] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!timeRange || !rewardType) return;

    try {
      setLoading(true);
      const res = await targetsController.getLeaderboards(timeRange, rewardType);
      setLeaderboards(res.json);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [timeRange, rewardType]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { leaderboards, loading, error, refetch: fetchData };
};


//
// 7️⃣ useFetchStaffProgressData
//
export const useFetchStaffProgressData = () => {
  const [staffProgressData, setStaffProgressData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await targetsController.getStaffProgressData();
      setStaffProgressData(res.json);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { staffProgressData, loading, error, refetch: fetchData };
};
